import { Box, Text, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const IconContainer = styled(Box)`
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
  box-shadow: ${({ theme }) => theme.box_shadow.input};
`

export const Column = styled(Box)`
  flex-direction: column;
  max-width: 100%;
  min-width: 150px;
`

export const Title = styled(Text)`
  p {
    font-size: 14px;
    color: ${({ theme }) => getThemeColor('grey_3', theme)};
  }
`

export const Value = styled(Text)`
  font-weight: 500;
  font-size: 14px;
`
